import { Box } from '@hivebrite/design-system/Box';
import { Skeleton as Szkieletor } from '@hivebrite/design-system/Skeleton';

import { Grid } from '../Grid';

export const Skeleton = () => (
  <Box
    m="auto"
    flexDirection="column"
    maxWidth={{
      _: '100%',
      m: '724px',
      l: '960px',
      xl: '1146px',
    }}
    mt={{ _: 0, m: 6 }}
    pb={6}
    dataTestId="skeleton"
  >
    <Grid>
      <header>
        <Szkieletor
          height={{ s: 'auto', m: 201, l: 271, xl: 338 }}
          style={{ borderRadius: '10px' }}
        />
        <Szkieletor height={32} mt={4} width="50%" />
      </header>
      <main>
        <Szkieletor height={16} mt={4} />
        <Szkieletor height={16} mt={2} />
        <Szkieletor height={16} mt={2} />
        <Szkieletor height={16} mt={2} />
        <Szkieletor height={16} mt={2} />
        <Szkieletor height={16} mt={2} />
        <Szkieletor height={16} mt={2} />

        <Szkieletor height={16} mt={4} />
        <Szkieletor height={16} mt={2} />
        <Szkieletor height={16} mt={2} />
        <Szkieletor height={16} mt={2} />
        <Szkieletor height={16} mt={2} />
        <Szkieletor height={16} mt={2} />
        <Szkieletor height={16} mt={2} />
      </main>
      <aside>
        <Szkieletor height={32} width="60%" />

        <Szkieletor height={16} mt={4} />
        <Szkieletor height={16} mt={4} />
        <Szkieletor height={16} mt={4} />

        <Box mt={2} flexDirection="column">
          <Szkieletor height={32} mt={4} width="50%" />
          <Szkieletor height={32} mt={4} width="50%" />
        </Box>
      </aside>
    </Grid>
  </Box>
);
